export type Lang = 'es' | 'en';

const STRINGS = {
  es: {
    open: 'Abrir chat',
    close: 'Cerrar chat',
    menu: 'Más opciones',
    newChat: 'Nueva conversación',
    placeholder: 'Escribe tu mensaje…',
    send: 'Enviar',
    start: 'Empezar a chatear',
    starting: 'Conectando…',
    name: 'Nombre',
    email: 'Correo',
    phone: 'Teléfono',
    namePh: 'Tu nombre',
    emailPh: 'tu@correo.com',
    phonePh: 'Tu número de celular',
    required: 'Este dato es obligatorio',
    invalidEmail: 'Revisa el correo',
    invalidPhone: 'Escribe un número válido',
    startError: 'No pudimos iniciar el chat. Inténtalo de nuevo.',
    sendError: 'No se pudo enviar. Revisa tu conexión e inténtalo otra vez.',
    notDelivered: 'No enviado · toca para reintentar',
    offline: 'Sin conexión. Reintentando…',
    slow: 'Sigue escribiendo, la respuesta está en camino…',
    today: 'Hoy',
    tomorrow: 'Mañana',
    pickTime: 'Elige un horario',
    pickedTime: (label: string) => `Elijo ${label}`,
    interested: (name: string) => `Me interesa ${name}`,
    extrasTitle: 'Extras opcionales',
    extras: 'Extras',
    noExtras: 'Sin extras, gracias',
    addExtras: (count: number) => (count === 1 ? 'Agregar 1 extra' : `Agregar ${count} extras`),
    addedExtras: (names: string[]) => `Agrega ${names.join(' y ')}`,
    confirmed: 'Reserva confirmada',
    code: 'Código',
    service: 'Servicio',
    when: 'Fecha y hora',
    where: 'Dirección',
    vehicle: 'Vehículo',
    price: 'Precio',
    addCalendar: 'Añadir a mi calendario',
    poweredBy: 'Atención con IA de',
    replies: 'Responde en segundos',
    launcher: '¿Te ayudamos? Escríbenos',
    closed: 'Esta conversación terminó.',
    privacy: 'Usamos tus datos solo para atender tu solicitud.',
    contactUs: 'Otras formas de contactarnos',
    contact: { whatsapp: 'WhatsApp', sms: 'Envíanos un SMS', call: 'Llámanos', email: 'Escríbenos un correo' }
  },
  en: {
    open: 'Open chat',
    close: 'Close chat',
    menu: 'More options',
    newChat: 'New conversation',
    placeholder: 'Type your message…',
    send: 'Send',
    start: 'Start chatting',
    starting: 'Connecting…',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    namePh: 'Your name',
    emailPh: 'you@email.com',
    phonePh: 'Your mobile number',
    required: 'This field is required',
    invalidEmail: 'Check the email address',
    invalidPhone: 'Enter a valid number',
    startError: "We couldn't start the chat. Please try again.",
    sendError: "Couldn't send. Check your connection and try again.",
    notDelivered: 'Not delivered · tap to retry',
    offline: 'Offline. Reconnecting…',
    slow: 'Keep typing, the answer is on its way…',
    today: 'Today',
    tomorrow: 'Tomorrow',
    pickTime: 'Pick a time',
    pickedTime: (label: string) => `I'll take ${label}`,
    interested: (name: string) => `I'm interested in ${name}`,
    extrasTitle: 'Optional extras',
    extras: 'Extras',
    noExtras: 'No extras, thanks',
    addExtras: (count: number) => (count === 1 ? 'Add 1 extra' : `Add ${count} extras`),
    addedExtras: (names: string[]) => `Add ${names.join(' and ')}`,
    confirmed: 'Booking confirmed',
    code: 'Code',
    service: 'Service',
    when: 'Date & time',
    where: 'Address',
    vehicle: 'Vehicle',
    price: 'Price',
    addCalendar: 'Add to my calendar',
    poweredBy: 'AI assistant by',
    replies: 'Replies in seconds',
    launcher: 'Questions? Chat with us',
    closed: 'This conversation has ended.',
    privacy: 'We only use your details to handle your request.',
    contactUs: 'Other ways to reach us',
    contact: { whatsapp: 'WhatsApp', sms: 'Text us', call: 'Call us', email: 'Email us' }
  }
};

export type Strings = (typeof STRINGS)['es'];

export function resolveLang(setting: string | undefined): Lang {
  if (setting === 'es' || setting === 'en') return setting;
  return (navigator.language || 'es').toLowerCase().startsWith('en') ? 'en' : 'es';
}

export const strings = (lang: Lang): Strings => STRINGS[lang];
